<template>
  <div>
      <GmapMap
          ref="mapRef"
          :center="myCenter"
          :zoom="zoom"
          map-type-id="terrain"
          :style="'width: ' + width + 'px; height: ' + height + 'px;'"
          class="size"
      >
          <gmap-custom-marker
        :marker="myCenter" :z-index="10"
      >
        <div @click="click(myCenter)" class="is-gant hover-item speech-bubble" style="border-radius: 3px; color: white; text-align: center;">
          <b-icon style="margin: 2px;" type="is-white" size="is-medium" :icon="type"></b-icon>
          <!-- <img  class="infoi" :width="picWidth" style="border-radius: 3px; margin: 1px;" :src="image"> -->

        </div>
    </gmap-custom-marker>
      </GmapMap>
</div>
</template>


<script>
  import GmapCustomMarker from 'vue2-gmap-custom-marker';
  export default {
    name: 'GMap',
    components: {
      'gmap-custom-marker': GmapCustomMarker,
      // 'cluster': GmapCluster
    },
    data: function () {
      return {
        myCenter: { lat: 45.508, lng: -73.587 },
        selectedHotel: {},
        selectedCar: {},
        type: null,
        zoom: 12,
        routeName: this.$route.name,
        picWidth: 55
      }
    },
    props: {
      lat: Number,
      long: Number,
      image: String,
      name: String,
      description: String,
      width: String,
      height: String,
      carOrHotel: String
    },
    methods: {
      getCenter(){
        this.myCenter = { lat: this.lat, lng: this.long };
      },
      click(pos){
        this.map.setZoom(15)
        this.map.panTo(pos)
      }
    },
    mounted(){
      this.getCenter()
      this.$refs.mapRef.$mapPromise.then((map) => {
        this.map = map;
      });
      this.selectedHotel = this.$store.state.bookTravel.result.hotel
      this.selectedCar = this.$store.state.bookTravel.result.car
      // console.log(this.$route.name)
      if (this.$route.name == 'cars'){
        this.selectedCar = {}
        this.type = 'car'
        this.picWidth="60"

      }
      else if (this.$route.name == 'hotels'){
        this.selectedHotel = {}
        this.type = 'bed'
        this.picWidth="100"
      }
      else{
        this.type = this.carOrHotel
      }
      // console.log(this.selectedCar)
      // console.log(this.selectedHotel)
      // console.log(this.image)
  }
}
</script>

<style>
  .speech-bubble {
    position: relative;
    border-radius: .4em;
    background-color: #ab323b;
  }
  .speech-bubble:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-top-color: #ab323b;
    border-bottom: 0;
    margin-left: -5px;
    margin-bottom: -5px;
  }
  @media screen and (max-width: 1023px) {
    .size {
      width: 100vw !important;
      height: 100vw !important;
      margin: auto !important;
    }
  }
</style>
